import * as React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import { useSelector } from "react-redux";

const Loader = () => {
  const loaderStyles = {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 9999,
    display: "block"
  };
  const isLoading = useSelector((state) => state.loading.isLoading);
  if (!isLoading) {
    return null;
  }
  return (
    <Box>
      <CircularProgress style={loaderStyles} color="success" />
    </Box>
  );
};
export default Loader;
